import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

/** A raised panel with the 20px card radius; `glow` draws exasol.com's gradient border for the one next step. */
export function Card({ className, glow = false, ...props }: ComponentProps<"section"> & { glow?: boolean }) {
  return (
    <section
      data-slot="card"
      className={cn("rounded-card border border-line bg-surface-raised p-5 text-ink", glow && "card-glow", className)}
      {...props}
    />
  );
}
